import {$} from "./boot";
import {AppConfig} from "./AppConfig";
import {tableRowRemoteRadio} from "./lib/RemoteRadio";
import {apiPost} from "./lib/SecuredAjax";
import {showToastError} from "./lib/boostrapToast";
import {Messages} from "./messages/Messages";

const messages = new Messages();

export class TransportListPage {
	private readonly canSwitch: boolean

	constructor({canSwitch}: { canSwitch?: boolean }) {
		this.canSwitch = canSwitch != undefined && canSwitch

		if (this.canSwitch) {
			const stateRadio = $('div[data-state-radio] input');

			tableRowRemoteRadio(stateRadio,
				radioInput => `${AppConfig.CP}/transports/${radioInput.getAttribute('data-transport')}/switchState`,
				radioInput => `"${radioInput.value}"`
			);

			stateRadio.on('change', function () {
				const input = $(this);
				if (!input.is(':checked')) return;

				const transportDisabled = input.val() === 'DISABLED';
				const id = input.closest('tr').data('id');
				const hasPosition = input.closest('tr').attr('has-position') === 'true';

				const hideButton = jQuery(`button#tState${id}_hide`);
				if (transportDisabled || !hasPosition) {
					hideButton.removeAttr('hidden');
				} else {
					hideButton.attr('hidden', '');
				}

				if (transportDisabled && hasPosition) {
					hideButton.removeAttr('disabled')
				} else {
					hideButton.attr('disabled', '')
				}
			});

			jQuery('button[id$="_hide"]').on('click', function () {
				const input = jQuery(this);
				const id = input.closest('tr').data('id');

				apiPost(`${AppConfig.CP}/transports/${id}/hide`, {})
					.then(res => {
						input.addClass('active');
						input.text(messages.get('transport.hidden'));
						input.attr('disabled', 'disabled');
						input.closest('tr').attr('has-position', 'false');
					})
					.catch(err => {
						showToastError(err);
					});
			});
		}
	}
}